import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EmojiPicker from 'components/EmojiPicker';
import ExpandableTextarea from 'components/ExpandableTextarea';
import AddGiphyIcon from 'components/Icon/AddGiphyIcon';
import AddMediaIcon from 'components/Icon/AddMediaIcon';
import { isEmbedded } from 'utils/mode';
import DisabledSubmitIcon from 'resources/UI_ButtonCommentSendDisabled.png';
import SubmitIcon from 'resources/UI_ButtonCommentSendActive.png';
import './MessageForm.css';

export const MESSAGE_TYPE_POST = 'post';
export const MESSAGE_TYPE_COMMENT = 'comment';
export const MESSAGE_TYPE_CHAT = 'chat';
export const MESSAGE_TYPE_IMAGE_CAPTION = 'caption';

const MESSAGE_PLACEHOLDER_TEXTS = {
  [MESSAGE_TYPE_POST]: 'Share your thoughts…',
  [MESSAGE_TYPE_COMMENT]: 'Share your thoughts…',
  [MESSAGE_TYPE_CHAT]: 'Type here to chat…',
  [MESSAGE_TYPE_IMAGE_CAPTION]: 'Share your thoughts…'
};

class MessageForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTextareaFocused: false
    };
  }

  handleTextareaFocus = () => {
    this.setState({ isTextareaFocused: true });
  };

  handleTextareaBlur = () => {
    this.setState({ isTextareaFocused: false });
  };

  componentDidMount() {
    if (this.props.autoFocus && this.messageInput) {
      this.messageInput.focus();
      const length = this.messageInput.value.length;
      this.messageInput.setSelectionRange(length, length);
    }

    if (this.props.setCommentInput && this.messageInput) {
      this.props.setCommentInput(this.messageInput);
    }
  }

  render() {
    const { isTextareaFocused } = this.state;
    const {
      onAddImageClick,
      onAddGiphyClick,
      onSubmit,
      disabled,
      message,
      placeholder,
      addEmoji,
      showEmojiPicker,
      onEmojiPicker
    } = this.props;
    const submitDisabled = disabled || !message.trim() ? true : false;

    return (
      <form onSubmit={onSubmit} aria-label="Message feed form">
        <div className="emoji-button-placeholder-container">
          {!isEmbedded() && (
            <EmojiPicker
              showEmojiPicker={showEmojiPicker}
              addEmoji={addEmoji}
              onEmojiPickerToggle={onEmojiPicker}
            />
          )}
          {placeholder && !message && !isTextareaFocused && (
            <span className="textarea-placeholder">
              {MESSAGE_PLACEHOLDER_TEXTS[placeholder]}
            </span>
          )}
        </div>
        <ExpandableTextarea
          onChange={this.props.onChange}
          onFocus={this.handleTextareaFocus}
          onBlur={this.handleTextareaBlur}
          onKeyDown={this.props.onKeyDown}
          value={message}
          disabled={this.props.disabled}
          innerRef={input => (this.messageInput = input)}
        />
        <div className="media-buttons-container">
          <button
            className="add-message-giphy"
            onClick={onAddGiphyClick}
            type="button"
            aria-label="Giphy upload button"
          >
            <AddGiphyIcon className="expand" size={25} alt="Upload GIF" />
          </button>
          <button
            className="add-message-media"
            onClick={onAddImageClick}
            type="button"
            aria-label="Image upload button"
          >
            <AddMediaIcon
              className="expand"
              size={'large'}
              alt="Upload Image"
            />
          </button>
        </div>
        <button
          className="submit-comment-button"
          type="submit"
          disabled={submitDisabled}
          aria-label="Submit comment button"
        >
          <img
            src={submitDisabled ? DisabledSubmitIcon : SubmitIcon}
            alt="Submit"
          />
        </button>
      </form>
    );
  }
}

MessageForm.propTypes = {
  onSubmit: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  message: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  setCommentInput: PropTypes.func
};

export default MessageForm;
